import React from 'react';
import { ListItemButton, ListItemText } from '@mui/material';

export const ListItem: React.FC<{ text: string }> = ({ text }) => {
  return (
    <ListItemButton divider>
      <ListItemText>{ text }</ListItemText>
    </ListItemButton>
  );
};